<app-process-filter
  [searchParams]="searchParams"
  (search)="doSearch()"
  (export)="doExport()">
</app-process-filter>

<p class="process-list__range" *ngIf="!isLoading && pagingModel && processes?.length > 0">
  {{ (pagingModel.pageNumber * pagingModel.pageSize) - pagingModel.pageSize + 1 }} - {{ pagingModel.pageNumber * pagingModel.pageSize }} de
  <button
    *ngIf="totalItems === null && !isCountLoading"
    type="button"
    class="process-list__count-eye"
    (click)="loadCount()"
    title="Ver total de itens">
    <i class="fa fa-eye"></i>
  </button>
  <i *ngIf="isCountLoading" class="fa fa-spinner fa-spin"></i>
  <span *ngIf="totalItems !== null">{{ totalItems | number:'1.0-0' }}</span>
</p>

<div class="process_list" [class.process_list--catalog]="isCatalogView" [class.process_list--empty]="!processes || processes.length === 0" *ngIf="!isLoading">
  <div class="process-item process-item_head" *ngIf="!isCatalogView && (processes?.length > 0)">
    <div class="process-item__row" [ngClass]="{'process-item__row_v2': totalColumns.length > 2}" *ngFor="let i of totalColumns">
      <p>{{ getColumnTitle(i) }}</p>
    </div>
    <div class="process-item__row" [ngClass]="{'process-item__row_v2': totalColumns.length > 2}">
      <p>Status</p>
    </div>
    <div class="process-item__row" [ngClass]="{'process-item__row_v2': totalColumns.length > 2}"></div>
  </div>

  <app-process-summary
      *ngFor="let process of processes"
      [process]="process"
      [isCatalogView]="isCatalogView"
      [totalColumns]="totalColumns"
      (onUpdatedItem)="updateList()"
      (onShowModalPrint)="toggleModalPrint($event)">
  </app-process-summary>
  <div class="process-empty" *ngIf="!processes || processes.length === 0">
    <span class="fa-stack process-empty__icon" aria-hidden="true">
      <i class="fa fa-circle fa-stack-2x process-empty__icon-bg"></i>
      <i class="fa fa-info fa-stack-1x process-empty__icon-fg"></i>
    </span>
    <span>Não há itens para serem exibidos.</span>
  </div>
</div>


<div class="pagination-container" *ngIf="!isLoading && (processes?.length > 0 || hasNextPage || hasPrevPage || currentPage > 1)">
  <div class="pagination-pages" role="group" aria-label="...">

    <!-- Paginação numérica completa (após contagem carregada) -->
    <ng-container *ngIf="totalPages !== null">
      <button *ngIf="countPage > 1" type="button" class="pagination-item" (click)="firstPages()"> &lt; &lt;</button>
      <button *ngIf="countPage > 1" type="button" class="pagination-item" (click)="previousPages(currentPage)"> &lt;</button>
      <button *ngFor="let pageNumber of obterPaginas(); let index = index;"
        type="button"
        class="pagination-item"
        (click)="mudarPagina(pageNumber)"
        [class.pagination-item--active]="isActive(pageNumber)">
        {{pageNumber}}
      </button>
      <button *ngIf="(countPage + 14) < totalPages" type="button" class="pagination-item" (click)="nextPages(currentPage)">&gt;</button>
      <button *ngIf="(countPage + 14) < totalPages" type="button" class="pagination-item" (click)="lastPages()">&gt;&gt;</button>
    </ng-container>

    <!-- Navegação simples via HATEOAS (antes de carregar contagem) -->
    <ng-container *ngIf="totalPages === null">
      <button *ngIf="hasPrevPage || currentPage > 1" type="button" class="pagination-item" (click)="mudarPagina(currentPage - 1)">&lt;</button>
      <button type="button" class="pagination-item pagination-item--active">{{ currentPage }}</button>
      <button *ngIf="hasNextPage" type="button" class="pagination-item" (click)="nextPages(currentPage)">&gt;</button>
    </ng-container>

  </div>
</div>


<!-- Modal Print -->
<div *ngIf="showModalPrint" class="bf-modal bf-modal__print" >
  <div class="modal-dialog modal-md" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Selecione os itens que deseja imprimir</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="toggleModalPrint()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">

          <div class="row">
            <div class="col-md-12" *ngFor="let itemAttr of itemsAttr">
              <div class="form-check text-left">
                <input type="checkbox"
                  class="form-check-input"
                  id=""
                  value="{{itemAttr.attributes[1].value}}"
                  checked
                  (change)="onValueChange($event)"  >
                <label class="form-check-label" for="">{{itemAttr.attributes[2].value}}</label>
              </div>
            </div>
          </div>

          <div _ngcontent-dhm-c145="" class="text-center">
            <button class="btn btn-info " (click)="sendPrint()">Imprimir Guias</button>
          </div>

        <!-- <div *ngFor="let itemAttr of itemsAttr">
          <input type="checkbox"  class="checkbox" value="{{itemAttr.attributes[1].value}}" checked (change)="onValueChange($event)" >
          {{itemAttr.attributes[2].value}}
        </div> -->
      </div>
    </div>
  </div>
</div>
